import makeStyles from "@mui/styles/makeStyles";

export const useMenuStyles = makeStyles({
  paper: {
    boxShadow: "0 8px 10px #130A2E20, 0 1px 2px #130A2E20",
    padding: 12,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontSize: 14,
    },
  },
});

export const useStyles = makeStyles({
  sizeSmall: {
    "& li": {
      fontSize: 12,
    },
  },
  sizeLarge: {
    "& li": {
      fontSize: 14,
    },
  },
});
